import React from "react";
import { AlertContainer } from "./alert-style";
import { AlertProps } from "./alert-dto";

const Alert = ({ children, type }: AlertProps) => {
  return (
    <AlertContainer className={type}>
      {children}
    </AlertContainer>
  );
};

export default Alert;
